import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { SurveyAnswerDetailDto } from 'src/app/bo/survey/survey-answer-detail';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { SurveyService } from 'src/app/services/survey.service';
import { ToggleComponent } from '@libs/front/components/toggle/toggle.component';
import { ButtonComponent } from '@libs/front/components/button/button.component';
import { ScaleComponent } from '../../../components/survey/scale/scale.component';
import { DeviceService } from 'src/app/services/device.service';
import { ScrollableComponent } from 'src/app/shared/components/scrollable/scrollable.component';

@Component({
  selector: 'app-supplier-feedback',
  templateUrl: './supplier-feedback.component.html',
  styleUrls: ['./supplier-feedback.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDatepickerModule,
    TranslateModule,
    NgSelectModule,
    ToggleComponent,
    ButtonComponent,
    ScaleComponent,
    ScrollableComponent
]
})
export class SupplierFeedbackComponent implements OnInit, OnChanges {
  constructor(private readonly fb: FormBuilder, private readonly surveyService: SurveyService,
    private readonly fonctionsService: FonctionsService
  ) {
  }
  ngOnInit(): void {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tirId) {
      this.rechargerDonnees.emit(true);
    }
    this.initializeForm();
  }
  @Input() tirId: number = 0;
  @Input() regionId: number = 0;
  supplierForm: FormGroup = new FormGroup({});
  @Input() surveyJsonForm: any;
  @Input() surveyResponses: any;
  @Input() hasWritePermission: boolean = false;
  @Output() rechargerDonnees = new EventEmitter<boolean>();
  readonly device = inject(DeviceService);
  dropDownItemsMap: { [key: string]: { id: number; text: string }[] } = {};

  initializeForm() {
    let group: any = {};
    this.dropDownItemsMap = {};
    if (!this.surveyJsonForm?.providerSurvey?.survey) return;

    this.surveyJsonForm.providerSurvey.survey.forEach((question: any) => {
      if (question.type === 'dropdown') {
        this.dropDownItemsMap[question.uniqueId] = question.values;
      }
      const savedResponse = this.surveyResponses?.find((resp: any) => resp.uniqueId === question.uniqueId);
      let initialValue: any = '';

      if (savedResponse) {
        if (question.type.includes("scale")) {
          initialValue = isNaN(savedResponse.value) ? savedResponse.value : Number(savedResponse.value);
        } else {
          switch (question.type) {
            case 'toggle':
              initialValue = savedResponse.value === "true";
              break;
            case 'date':
              initialValue = savedResponse.value ? new Date(savedResponse.value) : null;
              break;
            case 'number':
              initialValue = savedResponse.value ? Number(savedResponse.value) : null;
              break;
            case 'dropdown':
              initialValue = savedResponse.value !== '' && savedResponse.value != null
                ? (isNaN(Number(savedResponse.value)) ? savedResponse.value : Number(savedResponse.value))
                : null;
              break;
            default:
              initialValue = savedResponse.value;
          }
        }
      } else {
        initialValue = question.type === 'toggle' ? false : null;
      }


      group[question.uniqueId] = new FormControl(initialValue);
    });

    this.supplierForm = this.fb.group(group);

    if (!this.hasWritePermission)
      this.supplierForm.disable();
  }

  submitForm() {
    let responses = this.getMappedSurveyResponses();
    this.fonctionsService.loading_screen(true);
    this.surveyService.saveSurveyResponsesFromApi(this.tirId, responses, this.regionId, 'providerSurvey')
      .subscribe({
        next: (res) => {
          this.fonctionsService.launch_toast(true, false);
          this.fonctionsService.loading_screen(false);
        },
        error: (err) => {
          this.fonctionsService.loading_screen(false);
          this.fonctionsService.launch_toast(false, false);
        }
      });
  }

  getMappedSurveyResponses(): SurveyAnswerDetailDto[] {
    let mappedResponses: SurveyAnswerDetailDto[] = [];

    if (this.surveyJsonForm["providerSurvey"]) {
      this.surveyJsonForm["providerSurvey"].survey.forEach((question: any) => {
        let value = this.supplierForm.get(question.uniqueId)?.value;

        mappedResponses.push({
          type: question.type,
          uniqueId: question.uniqueId,
          text: question.text,
          value: value != null ? String(value) : ''
        });
      });
    }

    return mappedResponses;
  }


}
